export const globalSettingsProductsAdvancedRoadmapsHierarchyRoute = {
	name: 'global-settings-products-advanced-roadmaps-hierarchy',
	path: '/secure/PortfolioHierarchy.jspa',
};
